import type { Template } from "@/types";

export const PO_05_H0_V5: Template[] = [
    {
        id: "po-05-h0v5-01",
        name: "PO 01 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 89, y: 256, width: 218, height: 316, rotation: 0, imageRotation: 0 },
            { id: "2", x: 315, y: 256, width: 218, height: 316, rotation: 0, imageRotation: 0 },
            { id: "3", x: 541, y: 256, width: 218, height: 316, rotation: 0, imageRotation: 0 },
            { id: "4", x: 767, y: 256, width: 218, height: 316, rotation: 0, imageRotation: 0 },
            { id: "5", x: 993, y: 256, width: 217, height: 316, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-02",
        name: "PO 02 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 233, width: 254, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 262, y: 233, width: 253, height: 362, rotation: 0, imageRotation: 0 },
            { id: "3", x: 523, y: 233, width: 253, height: 362, rotation: 0, imageRotation: 0 },
            { id: "4", x: 784, y: 233, width: 253, height: 362, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1045, y: 233, width: 253, height: 362, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-03",
        name: "PO 03 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 129, y: 275, width: 193, height: 279, rotation: 0, imageRotation: 0 },
            { id: "2", x: 330, y: 275, width: 192, height: 279, rotation: 0, imageRotation: 0 },
            { id: "3", x: 678, y: 275, width: 192, height: 279, rotation: 0, imageRotation: 0 },
            { id: "4", x: 878, y: 275, width: 192, height: 279, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1078, y: 275, width: 191, height: 279, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-04",
        name: "PO 04 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 59, y: 161, width: 354, height: 506, rotation: 0, imageRotation: 0 },
            { id: "2", x: 421, y: 161, width: 175, height: 249, rotation: 0, imageRotation: 0 },
            { id: "3", x: 421, y: 418, width: 175, height: 248, rotation: 0, imageRotation: 0 },
            { id: "4", x: 697, y: 218, width: 273, height: 392, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 218, width: 272, height: 392, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-05",
        name: "PO 05 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 86, y: 161, width: 365, height: 506, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 458, y: 161, width: 119, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 458, y: 333, width: 119, height: 163, rotation: 0, imageRotation: 0 },
            { id: "4", x: 458, y: 504, width: 119, height: 163, rotation: 0, imageRotation: 0 },
            { id: "5", x: 796, y: 161, width: 356, height: 506, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-06",
        name: "Hr 06 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 101, y: 92, width: 448, height: 643, rotation: 0, imageRotation: 0 },
            { id: "2", x: 750, y: 92, width: 220, height: 318, rotation: 0, imageRotation: 0 },
            { id: "3", x: 750, y: 418, width: 220, height: 317, rotation: 0, imageRotation: 0 },
            { id: "4", x: 978, y: 92, width: 220, height: 318, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 418, width: 220, height: 317, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-07",
        name: "PO 07 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 95, y: 221, width: 270, height: 387, rotation: 0, imageRotation: 0 },
            { id: "2", x: 373, y: 158, width: 177, height: 251, rotation: 0, imageRotation: 0 },
            { id: "3", x: 373, y: 417, width: 177, height: 251, rotation: 0, imageRotation: 0 },
            { id: "4", x: 700, y: 221, width: 271, height: 387, rotation: 0, imageRotation: 0 },
            { id: "5", x: 979, y: 221, width: 270, height: 387, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-08",
        name: "PO 08 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 94, y: 90, width: 460, height: 647, rotation: 0, imageRotation: 0 },
            { id: "2", x: 727, y: 158, width: 365, height: 510, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1100, y: 158, width: 118, height: 165, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1100, y: 331, width: 118, height: 165, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1100, y: 504, width: 118, height: 164, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-09",
        name: "PO 09 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 73, y: 177, width: 323, height: 471, rotation: 0, imageRotation: 0 },
            { id: "2", x: 404, y: 177, width: 160, height: 232, rotation: 0, imageRotation: 0 },
            { id: "3", x: 404, y: 417, width: 160, height: 231, rotation: 0, imageRotation: 0 },
            { id: "4", x: 572, y: 177, width: 322, height: 471, rotation: 0, imageRotation: 0 },
            { id: "5", x: 902, y: 177, width: 322, height: 471, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h0v5-10",
        name: "PO 10 - H0V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h0_v5_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 74, y: 177, width: 323, height: 471, rotation: 0, imageRotation: 0 },
            { id: "2", x: 405, y: 177, width: 323, height: 471, rotation: 0, imageRotation: 0 },
            { id: "3", x: 736, y: 177, width: 322, height: 471, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1066, y: 177, width: 160, height: 232, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1066, y: 417, width: 160, height: 231, rotation: 0, imageRotation: 0 }
        ],
    }
];